import { tokens } from "../../../styles/theme";
import Header from "../../../components/Header";
import React, { useEffect, useState } from "react";
import { Box, useTheme, Button } from "@mui/material";
import axios from "axios";
import { Link } from "react-router-dom";
import ConfirmDialog from "../global/ConfirmDialog";
import * as sweetalert from "sweetalert";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "react-select";
import ReplayIcon from "@mui/icons-material/Replay";
import packageJson from "../../../../package.json";
import { getAllPaymentFatoraTable } from "../../../services/PaymentFatoraTabel";
import { Grid, TextField } from "@material-ui/core";
import { getAllServices } from "../../../services/Services";
import { getAllStaff } from "../../../services";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
function EditToolbar(props) {
  return (
    <>
      <GridToolbarContainer>
        <Box>
          <Link
            className="btn-create"
            style={{ textAlign: "left" }}
            to={{
              pathname: "/create-epayment",

              state: { fromDashboard: true },
            }}
          >
            إضافة دفع الكتروني
          </Link>
        </Box>
      </GridToolbarContainer>
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: "الدفعات",
            utf8WithBom: true,
          }}
        />
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const Banks = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [users, setUsers] = useState([]);
  
  const [UserSelectedd, setUserSelectedd] = useState([]);
    console.log(UserSelectedd,'UserSelectedd');
  const [userSelected, setUserSelected] = useState();
  const [mobileDistrbuter, SetmobileDistrbuter] = React.useState();
  const [mobileClient, SetmobileClient] = React.useState();
  const [PaymentId, setPayment] = React.useState();
  const [datefrom, setDateFrom] = useState();
  const [dateto, setDateTo] = useState();
  const [loading, setLoading] = useState(false);
  const [Calaculation, setCalaculation] = useState(0);
  const [Profites, setProfites] = useState(0);
  const handleChange = (selectedOption) => {
    setUserSelected(selectedOption);
    SetmobileDistrbuter(selectedOption.mobile);

  };
  const handleChangeMobileDistrubuter = (e) => {
    SetmobileDistrbuter(e.target.value);
    
  };
  const handleChangeMobileClient = (e) => {
    SetmobileClient(e.target.value);
  };
  const handleChangePaymentID = (e) => {
    setPayment(e.target.value);
  };
  const [isLoading, setIsLoading] = useState(false);
  const [ServicesData, setServices] = useState([]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState();
  useEffect(() => {
    setIsLoading(true);
    getAllServices()
      .then((res) => {
        setServices(res);
        setIsLoading(false);
      })
      .catch((err) => {
        setServices([]);
        setIsLoading(false);
      });

    return () => {};
  }, []);
  useEffect(() => {
    setIsLoading(true);
    axios
      .get(`${BaseUrl}/api/staff`, {
        withCredentials: true,
      })
      .then((res) => {
        setUserSelectedd(res.data.data);
      })
      .catch((err) => {
        setUserSelectedd([]);
      });
    return () => {};
  }, []);
  const staff_type = localStorage.getItem("staff_type");

  const mobile_number_login = localStorage.getItem("mobile_number_login");
  const type_order = [
    { id: 1, title: "Transfer Type 1" },
    { id: 2, title: "Transfer Type 2" },
    { id: 3, title: "Transfer Type 3" },
    // Add more options as needed
  ];
  const [pagination, setPagination] = useState({
    total_pages: 1,
    current_page: 1,
    total: 10, // Initially no total rows known
    count: 10, // Initially no total rows known
  });
  const options = UserSelectedd?.map((option) => ({
    value: option.id,
    mobile: option.mobile_number,
    label: `${option.first_name} ${option.middle_name || ''} ${option.last_name}`,

  }));
  console.log(users,'users');
  console.log(pagination,'pagination');
  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  
  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };
  const handleDateFromChange = (event) => {
    setDateFrom(event.target.value);
  };

  const handleDateToChange = (event) => {
    setDateTo(event.target.value);
  };
  const handleReload = (event) => {

    setPayment('');
    SetmobileClient('');
    setUserSelected('');
    SetmobileDistrbuter('');
    setCalaculation('');
    setProfites('0')
    setDateFrom("");
    setDateTo("");
    const data = {
      page: 1,

    };
    axios
      .post(`${BaseUrl}/api/getAllPaymentFatora`, data, {
        withCredentials: true,
      })
      .then((response) => {
        setUsers(response.data.data); // Setting users with response data
        const totalAmount = response.data.data.reduce(
          (acc, transaction) => acc + transaction.amount,
          0
        );
        setCalaculation(response.data.total_amount_sum);
        setProfites(response.data.total_amount_profit);
        setLoading(false);
        setPagination({
          ...pagination,
          total: response.data.pagination.total, // Total items count across all pages
          current_page: response.data.pagination.current_page,
          total_pages: response.data.pagination.total_pages,
          count: response.data.pagination.count,
        });
      })
      .catch((error) => {
        console.error("Failed to fetch data:", error);
        setUsers([]); // Setting users to an empty array in case of error
        setLoading(false);
      });
  
  }

  const handlefilter = (event) => {
    const data = {
      page: pagination.current_page,
      payment_id: PaymentId,
      mobile: mobileClient,
      staff_id: userSelected.value,
      mobile_number: mobileDistrbuter,
      from_date: datefrom,
      to_date: dateto,
    };
    axios
      .post(`${BaseUrl}/api/getAllPaymentFatora`, data, {
        withCredentials: true,
      })
      .then((response) => {
        setUsers(response.data.data); // Setting users with response data
        const totalAmount = response.data.data.reduce(
          (acc, transaction) => acc + transaction.amount,
          0
        );
        setCalaculation(response.data.total_amount_sum);
        setProfites(response.data.total_amount_profit);
        setLoading(false);
        setPagination({
          ...pagination,
          total: response.data.pagination.total, // Total items count across all pages
          current_page: response.data.pagination.current_page,
          total_pages: response.data.pagination.total_pages,
          count: response.data.pagination.count,
        });
      })
      .catch((error) => {
        console.error("Failed to fetch data:", error);
        setUsers([]); // Setting users to an empty array in case of error
        setLoading(false);
      });
  }
  useEffect(() => {


  },[PaymentId,mobileClient,userSelected,mobileDistrbuter,datefrom,dateto])
  useEffect(() => {
    setLoading(true);

    const data = {
      page: pagination.current_page,
      payment_id: PaymentId,
      mobile: mobileClient,
      staff_id: userSelected?.value,
      mobile_number: mobileDistrbuter,
      from_date: datefrom,
      to_date: dateto,
    };
    axios
      .post(`${BaseUrl}/api/getAllPaymentFatora`, data, {
        withCredentials: true,
      })
      .then((response) => {
        setUsers(response.data.data); // Setting users with response data
        const totalAmount = response.data.data.reduce(
          (acc, transaction) => acc + transaction.amount,
          0
        );
        setCalaculation(response.data.total_amount_sum);
        setProfites(response.data.total_amount_profit);
        setLoading(false);
        setPagination({
          ...pagination,
          total: response.data.pagination.total, // Total items count across all pages
          current_page: response.data.pagination.current_page,
          total_pages: response.data.pagination.total_pages,
          count: response.data.pagination.count,
        });
      })
      .catch((error) => {
        console.error("Failed to fetch data:", error);
        setUsers([]); // Setting users to an empty array in case of error
        setLoading(false);
      });
  }, [pagination.current_page]);
  const handlePageChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      current_page: newPage + 1,
    }));
  };
  const columns = [
    {
      field: "staff_name",
      headerName: "اسم الموزع",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
      renderCell: (params) => {
        const { staff_name,  } = params.row;
        const fullName = `${staff_name}`;
        return (
          <div>
            <div>{fullName}</div>
          </div>
        );
      },
    },
    {
      field: "staff_mobile_number",
      headerName: " رقم الموبايل الموزع",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "mobile",
      headerName: "رقم الموبايل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
 
    {
      field: "national_id",
      headerName: "الرقم الوطني",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "payment_id",
      headerName: "رقم العملية",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "amount",
      headerName: "القيمة الذي ارسلها للبنك",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
   
    {
      field: "increase_sell_price",
      headerName: "قيمة الذي دفعها الزبون",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "amount_after_bank_ratio",
      headerName: "القيمة",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "profit_amount",
      headerName: "العمولة",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "status",
      headerName: "حالة العملية",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
      renderCell: (params) => {
        const isActive = params.value === "pending";
        return isActive ? "معلق" : "مدفوع";
      },
    },
  ];
  return (
    <Box m="2px 5px 0px 5px">
      <Header />
      {ServicesData[4]?.name == "E_Payment" &&
      ServicesData[4]?.is_active == 1 ? (
        <Box
          m="40px 0 0 0"
          height="75vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.redAccent[1100],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.redAccent[1100],
              borderBottom: "none",
              fontSize: "10px !important",
            },
            "& .MuiDataGrid-cellContent": {
              fontSize: "10px !important",
              color: `${colors.grey[600]} !important`,
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.white[100],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.redAccent[1100],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
          }}
        >
          {" "}
   {  staff_type == "Admin" ?(
    <Grid style={{ display: "flex" }}>
            <div class="name-user-distributer">
              <InputLabel
                id="demo-mutiple-checkbox-label1"
                style={{
                  color: "#297FB8",
                  fontSize: "16px",
                  width: "100px",
                  marginBottom: "10px",
                }}
              >
                اسم الموزع
              </InputLabel>

              <Select
                value={userSelected}
                onChange={handleChange}
                options={options}
                getOptionLabel={(e) => e.label}
                getOptionValue={(e) => e.value}
                placeholder=" اسم الموزع"
              />
            </div>
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              style={{ marginRight: "10px" }}
              class="mobilr-distrbuter"
            >
              <TextField
                className="form-control mobile-control "
                fullWidth
                type="text"
                margin="normal"
                name="from_mobile_number"
                onChange={handleChangeMobileDistrubuter}
                value={mobileDistrbuter}
                label="رقم الموزع"
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              style={{ marginRight: "10px" }}
              class="mobilr-distrbuter"
            >
              <TextField
                className="form-control mobile-control "
                fullWidth
                type="text"
                margin="normal"
                name="from_mobile_number"
                onChange={handleChangeMobileClient}
                value={mobileClient}
                label="رقم العميل"
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>

            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              style={{ marginRight: "10px" }}
              class="mobilr-distrbuter"
            >
              <TextField
                className="form-control mobile-control "
                fullWidth
                type="text"
                margin="normal"
                name="payment"
                onChange={handleChangePaymentID}
                value={PaymentId}
                label="رقم عملية الدفع"
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>
            <div
              className="divdate"
              style={{ width: "400px", marginRight: "20px" }}
            >
              <div
                className="dateFrom date-distrubuter"
                style={{ marginTop: "3px" }}
              >
                <label
                  htmlFor="dateFrom"
                  style={{
                    color: "#297FB8 !important",
                    fontSize: "16px",
                    width: "100px",
                  }}
                >
                  من تاريخ:
                </label>
                <input
                  id="dateFrom"
                  type="date"
                  value={datefrom}
                  onChange={handleDateFromChange}
                />
              </div>
              <div
                className="dateTo date-distrubuter"
                style={{ marginTop: "3px" }}
              >
                <label
                  htmlFor="dateTo"
                  style={{
                    color: "#297FB8 !important",
                    fontSize: "16px",
                    width: "100px",
                  }}
                >
                  إلى تاريخ:
                </label>
                <input
                  id="dateTo"
                  type="date"
                  value={dateto}
                  onChange={handleDateToChange}
                />
              </div>
            </div>
            <Box
              className="div-btn-header button-distrbute"
            
            >
              <Button
                variant="contained"
                className="btn-submit"
                color="secondary"
                onClick={()=>{handlefilter()}}
              >
                فلترة
              </Button>
            </Box>
            <Grid item lg={2} md={2} sm={2} style={{ marginTop: "10px"  }}>
              <TextField
                className="form-control mobile-control"
                fullWidth
                type="text"
                margin="normal"
                label="النتيجة"
                // onChange={handleChange}
                value={Calaculation}
                disabled
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              style={{ marginRight: "10px", height: "40px",marginTop: "10px"   }}
            >
              <TextField
                className="form-control mobile-control"
                fullWidth
                type="text"
                margin="normal"
                label="العمولة"
                // onChange={handleChange}
                value={Profites}
                disabled
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>
            <Box
              className="div-btn-header button-distrbute"
              style={{ marginRight: "3%" }}
            >
              <Button
                style={{ marginRight: "3%" }}
                variant="contained"
                className="btn-submit "
                // color="secondary"
                onClick={()=>{handleReload()}}
              >
                <ReplayIcon />
              </Button>
            </Box>
          </Grid>
   ):(
    <></>
   )}
          <DataGridPro
               rows={users}
            className="field-table"
            columns={columns}
            editMode="row"
            pageSize={10}
            rowCount={pagination.total} // Total number of rows
            pagination
            paginationMode="server" // Set pagination mode to server
            onPageChange={handlePageChange}
            page={pagination.current_page - 1}
            rowModesModel={rowModesModel}
            onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
            onRowEditStart={handleRowEditStart}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            components={{
              Toolbar: EditToolbar,
            }}
            localeText={{
              toolbarColumns: "الأعمدة",
              toolbarFilters: "الفلاتر",
              toolbarDensity: "التباعد",
              toolbarExport: "تصدير",
              filterPanelAddFilter: "إضافة فلتر",
              filterOperatorContains: "تحتوي",
              filterOperatorEquals: "تساوي",
              filterOperatorStartsWith: "تبدأ ب",
              filterOperatorEndsWith: "تنتهي  ب",
              filterOperatorIsAnyOf: "هو أي من",
              filterOperatorIsEmpty: "فارغ",
              filterOperatorIsNotEmpty: "غير فارغ",
              toolbarDensityCompact: "دمج",
              toolbarDensityStandard: "معيار",
              toolbarDensityComfortable: "مريح",
              toolbarExportCSV: "تصدير CSV",
              toolbarExportPrint: "طباعة",
              filterPanelInputLabel: "القيمة",
              filterPanelInputPlaceholder: "ادخل القيمة",
              filterPanelColumns: "الاعمدة",
              filterPanelOperators: "العمليات",
              columnsPanelTextFieldLabel: "بحث عن عمود",
              columnsPanelTextFieldPlaceholder: "عنوان العمود",
            }}
            componentsProps={{
              toolbar: { setRows, setRowModesModel },
            }}
            experimentalFeatures={{ newEditingApi: true }}
          />
        </Box>
      ) : ServicesData[4]?.name == "E_Payment" &&
        ServicesData[4]?.is_active == 0 &&
        staff_type == "Admin" &&
        mobile_number_login == "0950555563" ? (
        <Box
          m="40px 0 0 0"
          height="75vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.redAccent[1100],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.redAccent[1100],
              borderBottom: "none",
              fontSize: "10px !important",
            },
            "& .MuiDataGrid-cellContent": {
              fontSize: "10px !important",
              color: `${colors.grey[600]} !important`,
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.white[100],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.redAccent[1100],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
          }}
        >
          {" "}
          <Grid style={{ display: "flex" }}>
            <div class="name-user-distributer">
              <InputLabel
                id="demo-mutiple-checkbox-label1"
                style={{
                  color: "#297FB8",
                  fontSize: "16px",
                  width: "100px",
                  marginBottom: "10px",
                }}
              >
                اسم الموزع
              </InputLabel>

              <Select
                value={userSelected}
                onChange={handleChange}
                options={options}
                getOptionLabel={(e) => e.label}
                getOptionValue={(e) => e.value}
                placeholder=" اسم الموزع"
              />
            </div>
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              style={{ marginRight: "10px" }}
              class="mobilr-distrbuter"
            >
              <TextField
                className="form-control mobile-control "
                fullWidth
                type="text"
                margin="normal"
                name="from_mobile_number"
                onChange={handleChangeMobileDistrubuter}
                value={mobileDistrbuter}
                label="رقم الموزع"
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              style={{ marginRight: "10px" }}
              class="mobilr-distrbuter"
            >
              <TextField
                className="form-control mobile-control "
                fullWidth
                type="text"
                margin="normal"
                name="from_mobile_number"
                onChange={handleChangeMobileClient}
                value={mobileClient}
                label="رقم العميل"
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>

            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              style={{ marginRight: "10px" }}
              class="mobilr-distrbuter"
            >
              <TextField
                className="form-control mobile-control "
                fullWidth
                type="text"
                margin="normal"
                name="payment"
                onChange={handleChangePaymentID}
                value={PaymentId}
                label="رقم عملية الدفع"
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>
            <div
              className="divdate"
              style={{ width: "400px", marginRight: "20px" }}
            >
              <div
                className="dateFrom date-distrubuter"
                style={{ marginTop: "3px" }}
              >
                <label
                  htmlFor="dateFrom"
                  style={{
                    color: "#297FB8 !important",
                    fontSize: "16px",
                    width: "100px",
                  }}
                >
                  من تاريخ:
                </label>
                <input
                  id="dateFrom"
                  type="date"
                  value={datefrom}
                  onChange={handleDateFromChange}
                />
              </div>
              <div
                className="dateTo date-distrubuter"
                style={{ marginTop: "3px" }}
              >
                <label
                  htmlFor="dateTo"
                  style={{
                    color: "#297FB8 !important",
                    fontSize: "16px",
                    width: "100px",
                  }}
                >
                  إلى تاريخ:
                </label>
                <input
                  id="dateTo"
                  type="date"
                  value={dateto}
                  onChange={handleDateToChange}
                />
              </div>
            </div>
            <Box
              className="div-btn-header button-distrbute"
           
            >
              <Button
                variant="contained"
                className="btn-submit"
                color="secondary"
                onClick={()=>{handlefilter()}}
              >
                فلترة
              </Button>
            </Box>
            <Grid item lg={2} md={2} sm={2} style={{ marginTop: "10px"  }}>
              <TextField
                className="form-control mobile-control"
                fullWidth
                type="text"
                margin="normal"
                label="النتيجة"
                // onChange={handleChange}
                value={Calaculation}
                disabled
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              style={{ marginRight: "10px", height: "40px",marginTop: "10px"   }}
            >
              <TextField
                className="form-control mobile-control"
                fullWidth
                type="text"
                margin="normal"
                label="العمولة"
                // onChange={handleChange}
                value={Profites}
                disabled
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>
            <Box
              className="div-btn-header button-distrbute"
              style={{ marginRight: "3%" }}
            >
              <Button
                style={{ marginRight: "3%" }}
                variant="contained"
                className="btn-submit "
                // color="secondary"
                onClick={()=>{handleReload()}}
              >
                <ReplayIcon />
              </Button>
            </Box>
          </Grid>
          <DataGridPro
            rows={users}
            className="field-table"
            columns={columns}
            editMode="row"
            pageSize={10}
            rowCount={pagination.total} 
            pagination
            paginationMode="server" // Set pagination mode to server
            onPageChange={handlePageChange}
            page={pagination.current_page - 1}
            rowModesModel={rowModesModel}
            onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
            onRowEditStart={handleRowEditStart}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            components={{
              Toolbar: EditToolbar,
            }}
            localeText={{
              toolbarColumns: "الأعمدة",
              toolbarFilters: "الفلاتر",
              toolbarDensity: "التباعد",
              toolbarExport: "تصدير",
              filterPanelAddFilter: "إضافة فلتر",
              filterOperatorContains: "تحتوي",
              filterOperatorEquals: "تساوي",
              filterOperatorStartsWith: "تبدأ ب",
              filterOperatorEndsWith: "تنتهي  ب",
              filterOperatorIsAnyOf: "هو أي من",
              filterOperatorIsEmpty: "فارغ",
              filterOperatorIsNotEmpty: "غير فارغ",
              toolbarDensityCompact: "دمج",
              toolbarDensityStandard: "معيار",
              toolbarDensityComfortable: "مريح",
              toolbarExportCSV: "تصدير CSV",
              toolbarExportPrint: "طباعة",
              filterPanelInputLabel: "القيمة",
              filterPanelInputPlaceholder: "ادخل القيمة",
              filterPanelColumns: "الاعمدة",
              filterPanelOperators: "العمليات",
              columnsPanelTextFieldLabel: "بحث عن عمود",
              columnsPanelTextFieldPlaceholder: "عنوان العمود",
            }}
            componentsProps={{
              toolbar: { setRows, setRowModesModel },
            }}
            experimentalFeatures={{ newEditingApi: true }}
          />
        </Box>
      ) : ServicesData[4]?.name == "E_Payment" &&
        ServicesData[4]?.is_active == 0 ? (
        <div class="services-no-available">
          هذه الخدمة غير متاحة
          <img src="7703205.webp" />
        </div>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default Banks;
